import { makeStyles } from '@material-ui/styles';

import type { Theme } from '@bizzabo/design-system';

interface InputStyleProps {
    fontSizeMobile?: number;
}

export const useStyles = makeStyles<Theme, InputStyleProps>(
    theme => ({
        footerContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            padding: 20,
            minHeight: 68,
            height: 68,
            transition: 'min-height 0.2s ease-in',
            borderTop: `1px solid ${theme.palette.greys[400]}`,

            [theme.breakpoints.up('sm')]: {
                padding: '24px 24px 4px',
            },
        },
        expandedFooter: {
            minHeight: 140,
            [theme.breakpoints.up('sm')]: {
                minHeight: 200,
            },
        },
        inputWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            position: 'relative',
            height: '100%',
            flexGrow: 1,
            backgroundColor: 'white',
            borderRadius: '36px',
            padding: '14px 20px',
            marginRight: '8px',
            border: `${theme.palette.greys[400]} solid 1px`,
        },
        inputText: props => ({
            border: 'none',
            outline: 'none',
            resize: 'none',
            width: '100%',
            fontFamily: 'Inter',
            fontSize: props.fontSizeMobile,
            color: theme.palette.greys[700],
            flexGrow: 1,
            overflow: 'auto',

            [theme.breakpoints.up('sm')]: {
                fontSize: 14,
            },

            '&::placeholder': {
                color: theme.palette.greys[400],
            },
            '&::-webkit-scrollbar': {
                width: '4px',
            },
            '&::-webkit-scrollbar-button': {
                width: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
                width: '10px',
                backgroundColor: theme.palette.greys[400],
                borderRadius: '20px',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: theme.palette.greys[500],
                },
            },
        }),
        inputTextStyles: {
            fontFamily: 'Inter',
            fontSize: '14px',
            cursor: 'text',
            color: theme.palette.greys[400],
            lineHeight: 1,
            margin: 0,
        },
        inputOptions: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            '& .anonymous-section': {
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                '& .anonymous-icon': {
                    fill: theme.palette.greys[500],
                },
                '& .anonymous-text': {
                    marginLeft: '4px',
                },
                '&.active': {
                    '& .anonymous-icon': {
                        fill: theme.palette.greys[700],
                    },
                    '& .anonymous-text': {
                        color: theme.palette.greys[700],
                    },
                },
            },
        },
        inputOptionsText: {
            fontFamily: 'Inter',
            fontSize: '12px',
            color: theme.palette.greys[500],
            lineHeight: 1.5,
            fontWeight: 400,
            margin: 0,
        },
        inputOptionsTextLimit: {
            color: 'red',
        },
        inputOptionsWithAnonymous: {
            justifyContent: 'space-between',
        },
        inputOptionsNoAnonymous: {
            justifyContent: 'flex-end',
        },
        sendIconButton: {
            padding: '7px 8px 5px 5px',
            backgroundColor: theme.customization.interactive.C10,
            '&:hover': {
                backgroundColor: theme.customization.interactive.C20,
            },
            '& svg': {
                fill: theme.palette.neutral[200],
            },
            '&:disabled': {
                cursor: 'auto',
                backgroundColor: theme.customization.interactive.C30,
                '& svg': {
                    fill: theme.palette.greys[100],
                },
            },
        },
        smileIconButton: {
            backgroundColor: theme.palette.greys[200],
            '& svg': {
                fill: theme.palette.greys[600],
            },
            '&:hover': {
                backgroundColor: theme.palette.greys[300],
            },
            '&:disabled': {
                cursor: 'auto',
            },
        },
        smileIconButtonOpen: {
            backgroundColor: theme.palette.greys[300],
            '& svg': {
                fill: theme.palette.greys[600],
            },
        },
        reactionsPickerSpanWrapper: {
            position: 'absolute',
            bottom: '160px',
            right: '0px',
            zIndex: 20,
            width: '100%',
            '& section': {
                width: '100% !important',
                borderRadius: '20px',
                '& .emoji-mart-scroll': {
                    '&::-webkit-scrollbar': {
                        width: '4px',
                    },
                    '&::-webkit-scrollbar-button': {
                        width: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        width: '10px',
                        backgroundColor: theme.palette.greys[400],
                        borderRadius: '20px',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: theme.palette.greys[500],
                        },
                    },
                },
            },
        },
    }),
    { classNamePrefix: 'input-footer' }
);
